import React from "react";

import "./header.css";

const content = () => {

  return (

    <div id="cons">

      <div id="inside">

        <h1>

          I'm a <span id="saas"></span>

        </h1>

        <button>Hire Me</button>

      </div>

      <img src="https://image.cnbcfm.com/api/v1/image/107241090-1684160036619-gettyimages-1255019394-AFP_33F44YL.jpeg?v=1685596344"></img>

    </div>

  );

};

 

export default content;